module.exports = __webpack_public_path__ + "static/img/Roboto-Regular.c817650.svg";